const utils = require('frontend-controller/lib/utils')

module.exports = {
    events: {
        userActions: {
            type: 'click',
            selector: 'button',
            action(event){
                const $target = $(event.target).closest('button')
                if($target.length > 0){
                    const {
                        fieldType,
                        buttonContext,
                        buttonMode,
                    } = $target[0].dataset || {}
                    const self = event.data.component

                    if(typeof (self || {})[fieldType || 'NOFUNCTIONATALL'] === 'function'){
                        self[fieldType].apply(self, [buttonContext, buttonMode])
                    }
                }
            }
        }
    },

    methods: {
        prepare(){
            this.model.parentEntity = this.getResourceRegisterContent('parentEntity') || {}
            const attributes = ((this.model.parentEntity || {}).entityData || {}).attributes || {}

            if(attributes.startTS){
                const timeParts = []
                timeParts.push(utils.moment(attributes.startTS).format('DD.MM.YYYY HH:mm'))
                if(attributes.endTS){
                    timeParts.push(utils.moment(attributes.endTS).format('HH:mm'))
                }

                let lastCoreUpdateAt = attributes.lastInnerCoreUpdateAt
                if(attributes.status === 'agreed'){
                    lastCoreUpdateAt = attributes.lastCoreUpdateAt
                }

                attributes.showTime = {
                    time:       timeParts.join(' - '),
                    startTS:    attributes.startTS,
                    endTS:      attributes.endTS,
                    duration:   attributes.duration,
                }
                const myStatus = {
                    status: attributes.status,
                    statusOutDated: attributes.statusOutDated,
                }
                attributes.myJobs = {
                    myJobID: {
                        timeIndex: 0,
                        projectTermJobID: attributes.projectTermJobID,
                        nextPositiveStatus: attributes.nextPositiveStatus,
                        job: attributes.job || {},
                        skills: attributes.skills,
                        myStatus,
                        showTime: attributes.showTime,
                        lastCoreUpdateAt,
                    }
                }
                attributes.customer = {
                    companyName: attributes['customerCompanyName'] || '',
                }
                attributes.isInPast = attributes.allJobsInPast
                attributes.myLeastJobStatus = myStatus
                attributes.nrOfMyNullJobStatus = 0
                attributes.maxLastCoreUpdateAt = lastCoreUpdateAt
            }
        },

        async edit(buttonContext, buttonMode){
            const baseActionKey = `edit_${buttonContext}`

            if(buttonContext === 'projectTermJobStatus'){
                const nextStatus = buttonMode // agreed, revoked, applied, waitlisted

                const {
                    projectTermJobID,
                    status,
                    statusOutDated,
                } = ((this.model.parentEntity || {}).entityData || {}).attributes || {}

                if(projectTermJobID && (nextStatus === 'applied' || nextStatus === 'waitlisted' || nextStatus === 'agreed' || nextStatus === 'revoked') && (status !== nextStatus || statusOutDated)){
                    try {
                        await this.performAction(
                            this.prepareAction(
                                baseActionKey,
                                undefined,
                                undefined,
                                {
                                    source: {
                                        submit: {
                                            data: {
                                                resourceParams: {
                                                    projectTermJobID,
                                                    status: nextStatus,
                                                }
                                            }
                                        }
                                    }
                                }
                            ),
                        )

                        let modal
                        this.closest('base_modal_modal', c => modal = c)
                        if(modal){
                            if(!await modal.processDecision(this, 'submit', buttonMode, { status: nextStatus })){
                                await modal.hide()
                            }
                        }
                    } catch (error){
                        console.log(error)
                    }
                }
            }

            return utils.promise.resolve()
        },
    },
    // hooks: {
    //     attach($element, options){
    //         console.log(this.getResourceRegisterContent('parentEntity'))
    //     },
    // },
}